import { I18NextContext } from "./services/i18nService";

const timePickerTemplate = `
	<div
		class="timepicker-popover-content"
		uib-timepicker
		ng-model="$ctrl.timepickerDate"
		hour-step="1"
		minute-step="15"
		arrowkeys="true"
		show-meridian="$ctrl.isTwelveHour"
		click-outside="$ctrl.handleClickOutside()"
	>
	</div>
`;

export default function bootstrapper(
	$rootScope,
	$templateCache,
	uiState,
	config,
	$logger
) {
	$rootScope.uiState = uiState;

	$templateCache.put("time-picker-template.html", timePickerTemplate);

	I18NextContext.Instance.init($logger);
}
